import "./detailpage.scss";
import { MARKET_STATUS, MARKET_STATUS_BACKGROUNDS, MARKET_STATUS_TEXT_COLORS } from "../../utils/MarketStatus";
import { useTranslation } from "react-i18next";

const PoolStatusText = ({ poolstatus }) => {
  const { t } = useTranslation();
    return (
        <span className="live-box" style={{ backgroundColor: MARKET_STATUS_BACKGROUNDS[poolstatus], color: MARKET_STATUS_TEXT_COLORS[poolstatus], }}>
            {t(MARKET_STATUS[poolstatus])}
        </span>
    );
};

export default PoolStatusText;
